export default __webpack_public_path__ + "static/media/nos02.b723ea71.png";